import { Typography, Box } from '@material-ui/core';
import { parseRichText } from '../../../../utils/stringProcessor';

export default function TextMessage({ message }) {
  const text = (message?.content?.text || message?.text || '') || '';
  const isOptimistic = message?.isOptimistic;

  // Split paragraphs for spacing
  const renderParagraphs = (text) => {
    const paragraphs = String(text).split(/\n\s*\n/);
    return paragraphs.map((paragraph, pIndex) => (
      <Box key={pIndex} component="div" style={{ marginBottom: pIndex < paragraphs.length - 1 ? '8px' : '0' }}>
        {parseRichText(paragraph)}
      </Box>
    ));
  };

  return (
    <Typography
      variant="body2"
      component="div"
      style={{
        opacity: isOptimistic && message?.status === 'sending' ? 0.7 : 1,
        lineHeight: 1.4,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        wordWrap: 'break-word',
      }}
    >
      {renderParagraphs(text)}
    </Typography>
  );
}